<template>
	<div class="customizedservice">
		<div class="banner">
			<img src="~@/assets/image/cbanner.png">
			<div class="banner_txt">

			</div>
		</div>
    <CForm ></CForm>
		<div class="row_ad">
			<div class="container flex swiperflex">
				<div class="zq_left">
					<div class="title">展特易展台<span>定制优势</span></div>
					<div class="ad_row_list">
						<div class="ad_row">
							<span>多</span>
							<div>500+海量展台设计方案参考</div>
						</div>
						<div class="ad_row">
							<span>块</span>
							<div>创意设计与你共享你的展台你做主</div>
						</div>
						<div class="ad_row">
							<span>好</span>
							<div>专属设计师顾问式服务</div>
						</div>
						<div class="ad_row">
							<span>省</span>
							<div>模块化定制了不起的自主搭建</div>
						</div>
					</div>
				</div>
				<div class="zq_right">
          <div class="zq_right_cover">
            <div class="swiper-container ad_row_right">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="onecase in articleList">
                  <img v-bind:src="onecase.cover" />
                  <div class="case_des">
                    <div class="case_name">{{onecase.title}}</div>
                    {{onecase.brief}}
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-pagination"></div>
              <div class="swiper-button-next"></div>
            </div>
          </div>
				</div>
			</div>

		</div>

		<div class="step_row">
			<div class="container step_container">
				<div class="step">
					<img src="~@/assets/image/step1.svg">
					<div class="title">①注册会员</div>
					<div class="score">完善账户信息获得积分</div>
				</div>
				<div class="step">
					<img src="~@/assets/image/step2.svg">
					<div class="title">②需求调研</div>
					<div class="score">提交需求信息表，系统进行预分配</div>
				</div>
				<div class="step_t_row">
					<div class="step_t">展特易</div>
					<div class="step_t">展台<span>定制流程</span></div>
					<div class="des">根据需求，选择合适的方案即可在线下单，并且时时查看制作进度。</div>
				</div>
				<div class="step">
					<img src="~@/assets/image/step3.svg">
					<div class="title">③专属设计师对接</div>
					<div class="score">设计缴费-进行一对一沟通</div>
				</div>
				<div class="step">
					<img src="~@/assets/image/step4.svg">
					<div class="title">④可视化在线定制</div>
					<div class="score">进入定制可视界面，在线设计方案</div>
				</div>
				<div class="step">
					<img src="~@/assets/image/step5.svg">
					<div class="title">⑤方案确认</div>
					<div class="score">客户确认方案及报价，再下单</div>
				</div>
				<div class="step">
					<img src="~@/assets/image/step6.svg">
					<div class="title">⑥在线下单</div>
					<div class="score"></div>
				</div>
			</div>
		</div>


    <div class="inquiry_row">
      <img src="~@/assets/image/cssbj.png" />
      <div class="inquiry_row_txt">
        <div class="container">
          <div class="title">需求调研</div>
          <ul class="inquiry_list">
            <li>• 通过线上简易信息表单填写提交</li>
            <li>• 系统快速识别定制需求，进行方案和设计师预匹配。</li>
          </ul>
        </div>
      </div>
    </div>
		<div class="service">
			<img src="~@/assets/image/csservice.jpg">
			<div class="corver">
				<div class="title">150人团队保障产品与服务</div>
				<div class="services">
					<div class="item">
						<div class="num">20%</div>
						<div class="txt">顾问团队</div>
					</div>					
					<div class="item">
						<div class="num">5%</div>
						<div class="txt">客户成功团队</div>
					</div>
					<div class="item">
						<div class="num">20%</div>
						<div class="txt">售后服务团队</div>
					</div>	
					<div class="item">
						<div class="num">50%</div>
						<div class="txt">技术团队</div>
					</div>		
					<div class="item">
						<div class="num">3%</div>
						<div class="txt">设计团队</div>
					</div>														
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import CForm from '@/components/zqtool/CForm.vue';
	export default {
		name: "CustomizedService",
		components: {CForm},
		props: {},
		data() {
			return {
				articleList:[],
				
			};
		},
		watch: {},
		computed: {},
		methods: {
			getArticleList(type_id) {
				let where = {
					type_id: type_id,
					limit:3,
				};
				this.$api.articleList(where).then(res => {
					if (res.status) {
						this.articleList = res.data.list;
			this.$nextTick(function() {
				let galleryTop = new Swiper('.ad_row_right', {
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev',
					spaceBetween: 0,
					slidesPerView: 1,
					loop: true,
					pagination: '.swiper-pagination',
					paginationType: 'custom',
					observer: true, //修改swiper自己或子元素时，自动初始swiper
					observeParents: true, //修改swiper的父元素时,自动初始swiper					
					paginationCustomRender: function(swiper, current, total) {
						return "<div class='custompagination'><div class='cur'>" + current + "</div>" +
							'<div class="pagination_txt">/</div>' + '<div class="pagination_txt">' +
							total + '</div></div>';
					}
				});

			});						
					}
				})
			},

		},
		created() {
			this.getArticleList();
			
		},
		mounted() {

		}
	};
</script>

<style lang="scss" scoped>
	@import "@/assets/css/customizedservice.scss";
	.banner > img{
		width: 100%;
	}
</style>
